import type React from 'react';
import { PageHead } from 'ui/kit/PageHead';
import { useState } from 'react';
import { useNavigate } from 'react-router';

import { SupportContactForm } from 'components/SupportContactForm/SupportContactForm';
import { useAuthSession } from 'hooks/useAuthSession';
import { FadeIn, StepBody } from 'ui/kit/uiMotion';
import { marketingLinks } from 'utils/siteLinks';

import s4 from './s4Screen.module.scss';

const maskEmail = (email: string) => {
  const [name, domain] = email.split('@');
  if (!name || !domain) return email;
  return `${name.slice(0, 1)}***@${domain}`;
};

export const Help: React.FC = () => {
  const navigate = useNavigate();
  const { data: session } = useAuthSession();
  const [sent, setSent] = useState<{ subject: string } | null>(null);
  const email = session?.email ? maskEmail(session.email) : 'почту аккаунта';

  if (sent) {
    return (
      <FadeIn>
        <StepBody stepKey='support-sent'>
          <main className={s4.page}>
            <PageHead crumb={<>Личный кабинет / Поддержка</>} title={<>Обращение отправлено</>} />
            <section className={s4.card}>
              <h2 className={s4.cardTitle}>Обращение отправлено</h2>
              <span className={s4.chip}>Отправлено</span>
              <p className={s4.label}>Тема</p>
              <p className={s4.body}>{sent.subject}</p>
              <p className={s4.label}>Куда придет ответ</p>
              <p className={s4.body}>На почту аккаунта: {email}</p>
              <p className={s4.hint}>
                Срок ответа не указан. Проверь почту аккаунта и папку Спам. Пароль и коды в
                переписку не присылай.
              </p>
              <div className={s4.actions}>
                <button type='button' className={s4.primary} onClick={() => navigate('/profile/settings')}>
                  Вернуться в настройки
                </button>
                <button type='button' className={s4.secondary} onClick={() => navigate('/profile/tasks')}>
                  К моим задачам
                </button>
              </div>
            </section>
          </main>
        </StepBody>
      </FadeIn>
    );
  }

  return (
    <FadeIn>
      <main className={s4.page}>
        <PageHead crumb={<>Личный кабинет / Поддержка</>} title={<>Обращение в поддержку</>} />
        <section className={s4.card}>
          <h2 className={s4.cardTitle}>Как мы можем помочь?</h2>
          <p className={s4.body}>
            Короткие шаги по заявке, чату и кабинету - в{' '}
            <a href={marketingLinks.guides}>инструкциях</a>.
          </p>
          <SupportContactForm
            roleLabel='ученик'
            replyEmail={email}
            onSent={(payload) => setSent({ subject: payload.subject })}
            onCancel={() => navigate('/profile/settings')}
          />
        </section>
      </main>
    </FadeIn>
  );
};
